export default "__VITE_ASSET__CBPSI9KY__"